import { AspectRatio, Box, GridItem, GridItemProps } from '@chakra-ui/react';
import { getCdnImageUrl } from '@jurnee/common/src/utils/core';

interface Props {
  path: string;
  colSpan?: GridItemProps['colSpan'];
}

export function GridItemImage({ path, ...inherited}: Props & GridItemProps) {
  return (
    <GridItem {...inherited}>
      <AspectRatio ratio={1.5} w="100%" overflow="hidden">
        <Box
          bgSize="cover"
          bgPosition="center"
          bgImage={`url('${getCdnImageUrl(path)}')`}
          bgColor="gray.200"
        />
      </AspectRatio>
    </GridItem>
  );
}